import React from "react";
import {twMerge} from 'tailwind-merge'

interface InputProps {
    id: string;
    onChange: (value: string) => void;
}

export default function RadioSelector({
                                          id,
                                          value,
                                          values,
                                          onChange,
                                          version = 'simple', // button
                                          type=null,
                                          ...rest
                                      }: InputProps) {

    if (version === 'button') {
        return (
            <div className="rounded-xl border-white border-2 flex justify-center h-[40px]">
                {values.map((item, index) => {
                    let selected = (item.value === value);
                    let className = "";
                    if (selected) {
                        className = "text-black bg-white"
                    }
                    let basis = 1 / values.length;  // Util pour que chaque item fasse la meme largeur, qq soit leur contenu
                    return (
                        <div
                            key={index}
                            className={twMerge(className, "font-bold grow basis-" + basis + " rounded-[8px] -m-[1px] flex justify-center items-center cursor-pointer")}
                            onClick={(e) => onChange(item.value)}>
                            {item.icon ? <img src={item.icon} className={twMerge("w-6 h-6 mr-1", selected ? "invert" : "" )}/> : null}
                            {item.label}
                        </div>
                    );
                })}
            </div>
        );
    }

    let properties = "flex flex-start gap-4";
    if(version === 'list') {
        properties = twMerge(properties, "flex-col");
    }
    else
    {
        properties = twMerge(properties, "h-[40px]");
    }

    // Version radio
    return (
        <div className={properties}>
            {values.map((item, index) => {
                let className = "";
                let selected = (item.value === value);
                let basis = 1 / values.length;  // Util pour que chaque item fasse la meme largeur, qq soit leur contenu
                return (
                    <div
                        key={index}
                        className={twMerge(className, "font-bold basis-" + basis + " rounded-[8px] -m-[1px] flex justify-left items-center ")}>
                        <input type={"radio"}
                               className="w-6 h-6 mr-1 cursor-pointer appearance-none border-[3px] border-white rounded-full relative"
                               checked={selected}
                               onChange={(e) => onChange(item.value)}
                               id={'value_' + item.value}
                        />
                        {selected ?
                            <div
                                className="absolute !w-3 !h-3 rounded-full bg-white ml-[6px]"
                            />
                            : null}
                        <label className="cursor-pointer" htmlFor={'value_' + item.value}>{item.label}</label>
                    </div>
                );
            })}
        </div>);
}